<aside *ngIf="error" class="navbar configuration-app-menu p-3" aria-label="Application navigation unavailable"><div role="alert">{{error}} <button class="btn btn-sm" type="button" [disabled]="loading" (click)="loadApp()">Retry navigation</button></div></aside>
<ng-container *ngIf="app as currentApp">
  <aside *ngIf="vertical; else horizontalMenu" class="navbar navbar-vertical navbar-expand-lg configuration-app-menu" data-bs-theme="dark">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#shared-app-sidebar"
        aria-controls="shared-app-sidebar" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="shared-app-sidebar">
        <ul class="navbar-nav pt-lg-3">
          <li class="nav-item dropdown" *ngFor="let item of currentApp.menu; trackBy: trackItem"
            [class.active]="isActive(item)" [class.show]="openedItem === item">
            <a class="nav-link" [class.dropdown-toggle]="item.children.length" [class.show]="openedItem === item"
              [attr.aria-expanded]="item.children.length ? openedItem === item : null"
              [routerLink]="linkPath(item.link)" [queryParams]="linkQueryParams(item.link)" (click)="toggle(item, $event)">
              <span class="nav-link-icon d-md-none d-lg-inline-block" [innerHTML]="item.icon | safeSvg"></span>
              <span class="nav-link-title">{{ item.name }}</span>
            </a>
            <div class="dropdown-menu" [class.show]="openedItem === item" *ngIf="item.children.length">
              <ng-container *ngFor="let child of item.children; trackBy: trackItem">
                <div class="app-menu-group" *ngIf="child.children.length; else verticalLeaf">
                  <div class="app-menu-group-title">{{ child.name }}</div>
                  <a class="dropdown-item" *ngFor="let leaf of child.children; trackBy: trackItem"
                    [routerLink]="linkPath(leaf.link)" [queryParams]="linkQueryParams(leaf.link)" [class.active]="isActive(leaf)" (click)="close()">{{ leaf.name }}</a>
                </div>
                <ng-template #verticalLeaf>
                  <a class="dropdown-item" [routerLink]="linkPath(child.link)" [queryParams]="linkQueryParams(child.link)" [class.active]="isActive(child)" (click)="close()">{{ child.name }}</a>
                </ng-template>
              </ng-container>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </aside>

  <ng-template #horizontalMenu>
    <div class="menu-content-wrap">
      <div class="container-fluid menu-group d-flex align-items-center">
        <a class="navbar-brand ms-2 me-5 h1 py-3" [routerLink]="currentApp.route">{{ currentApp.name }}</a>
        <ul class="navbar-nav d-flex flex-row align-items-center mb-0 app-menu-nav">
          <li class="nav-item dropdown" *ngFor="let item of currentApp.menu; trackBy: trackItem"
            [class.active]="isActive(item)" [class.show]="openedItem === item">
            <a class="nav-link" [class.dropdown-toggle]="item.children.length" [class.show]="openedItem === item"
              [routerLink]="linkPath(item.link)" [queryParams]="linkQueryParams(item.link)" (click)="toggle(item, $event)">
              <span class="nav-icon-wrap"><span class="svg-icon" [innerHTML]="item.icon | safeSvg"></span></span>
              <span class="nav-link-text">{{ item.name }}</span>
            </a>
            <div class="dropdown-menu" [class.show]="openedItem === item" *ngIf="item.children.length">
              <ng-container *ngFor="let child of item.children; trackBy: trackItem">
                <div class="app-menu-group" *ngIf="child.children.length; else horizontalLeaf">
                  <div class="app-menu-group-title">{{ child.name }}</div>
                  <a class="dropdown-item" *ngFor="let leaf of child.children; trackBy: trackItem"
                    [routerLink]="linkPath(leaf.link)" [queryParams]="linkQueryParams(leaf.link)" [class.active]="isActive(leaf)" (click)="close()">{{ leaf.name }}</a>
                </div>
                <ng-template #horizontalLeaf>
                  <a class="dropdown-item" [routerLink]="linkPath(child.link)" [queryParams]="linkQueryParams(child.link)" [class.active]="isActive(child)" (click)="close()">{{ child.name }}</a>
                </ng-template>
              </ng-container>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</ng-container>
